export { default as ModalPage } from './ModalPage';
export { default as ModalPageHeader } from './components/ModalPageHeader';
export * from './components/ModalPageHeader/ModalPageHeader.types';
export { default as ModalPageTitle } from './components/ModalPageTitle';
export { default as ModalPageContent } from './components/ModalPageContent';
export * from './components/ModalPageContent/ModalPageContent.types';
